import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LessonBlock from './LessonBlock';


function CourseSidebar({ curriculum }) {
  const { id } = useParams();
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (!curriculum.length || hasScrolled.current) return;

    let attempts = 0;
    let timer;

    const tryScroll = () => {
      const container = containerRef.current;
      if (!container) return;

      const activeEl = container.querySelector('.uk-active');
      if (!activeEl) return;

      const scrollEl = container.querySelector('.simplebar-content-wrapper');
      if (scrollEl) {
        const containerRect = scrollEl.getBoundingClientRect();
        const activeRect = activeEl.getBoundingClientRect();
        scrollEl.scrollTop += activeRect.top - containerRect.top - scrollEl.clientHeight / 3;
        hasScrolled.current = true;
      } else if (attempts < 15) {
        attempts++;
        timer = setTimeout(tryScroll, 100);
      } else {
        activeEl.scrollIntoView({ block: 'center' });
        hasScrolled.current = true;
      }
    };

    timer = setTimeout(tryScroll, 200);
    return () => clearTimeout(timer);
  }, [curriculum]);

  const course = { slug: id };

  const query = search.toLowerCase().trim();
  const filteredCurriculum = query
    ? curriculum
        .map(lesson => {
          if (lesson.title.toLowerCase().includes(query)) {
            return lesson;
          }
          const matchedParts = lesson.lesson_parts.filter(lp =>
            lp.title.toLowerCase().includes(query)
          );
          return matchedParts.length > 0
            ? { ...lesson, lesson_parts: matchedParts }
            : null;
        })
        .filter(Boolean)
    : curriculum;

  return (
    <div className="course-sidebar">
      <div className="course-sidebar-title">
        <h3>{t("lesson_part_view.table_of_contents")}</h3>
      </div>

      <div className="sidebar-search">
        <input
          className="sidebar-search__input"
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={t("sidebar.search_placeholder", "Search lessons...")}
        />
        {search && (
          <button className="sidebar-search__clear" onClick={() => setSearch('')}>
            <i className="icon-feather-x"></i>
          </button>
        )}
      </div>

      <div ref={containerRef} className="course-sidebar-container" data-simplebar="data-simplebar">
        <ul
          className="course-video-list-section"
          uk-accordion="uk-accordion"
          style={{ display: filteredCurriculum.length > 0 ? undefined : 'none' }}
        >
          {filteredCurriculum.map((lesson) =>
            <LessonBlock key={"lesson" + lesson.id} course={course} lesson={lesson} />
          )}
        </ul>
        <p
          className="sidebar-search__empty"
          style={{ display: filteredCurriculum.length === 0 ? undefined : 'none' }}
        >
          {t("sidebar.no_results", "No lessons found.")}
        </p>
      </div>
    </div>
  );
}

export default CourseSidebar;
